export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00426.a8af09c5.png";